import { render } from "./your-details-component.vue?vue&type=template&id=2afa8f9a&scoped=true"
import script from "./your-details-component.vue?vue&type=script&lang=js"
export * from "./your-details-component.vue?vue&type=script&lang=js"

import "./your-details-component.vue?vue&type=style&index=0&id=2afa8f9a&lang=scss&scoped=true"

import exportComponent from "/builds/bluemantis/origo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2afa8f9a"]])

export default __exports__